import './App.css';

function App() {
  return (
    <div className="App">
      Welcome to my Cloudflare Demo Page!😎😎😎
    </div>
  );
}

export default App;
